import React from "react";
import ReactMarkdown from "react-markdown";
import { useNavigate } from "react-router-dom";

export default function MessageBubble({ role, children }) {
  const navigate = useNavigate();

  const isAssistant = role === "assistant";
  const baseCls =
    "px-3 py-2 rounded-2xl text-sm max-w-[85%] whitespace-pre-wrap leading-relaxed";
  const cls = isAssistant
    ? `${baseCls} bg-white border text-gray-900`
    : `${baseCls} bg-blue-600 text-white ml-auto`;

  const onClick = (e) => {
    const a = e.target.closest("a");
    if (!a) return;

    const href = a.getAttribute("href") || "";

    // HashRouter: "#/annonces/123"
    if (href.startsWith("#/")) {
      e.preventDefault();
      navigate(href.slice(1)); // "#/foo" -> "/foo"
      return;
    }

    // BrowserRouter: "/annonces/123"
    if (href.startsWith("/") && !href.startsWith("//")) {
      e.preventDefault();
      navigate(href);
      return;
    }

    // externe Links: in neuem Tab, sicher öffnen
    if (/^https?:\/\//i.test(href)) {
      a.setAttribute("target", "_blank");
      a.setAttribute("rel", "noopener noreferrer");
    }
  };

  return (
    <div className={cls} onClick={onClick}>
      {isAssistant ? (
        <ReactMarkdown
          components={{
            a: (props) => (
              <a
                {...props}
                className="text-blue-600 underline hover:text-blue-700"
              />
            ),
            li: (props) => <li className="mb-1" {...props} />,
            ul: (props) => <ul className="list-disc pl-5 space-y-1" {...props} />,
          }}
        >
          {String(children ?? "")}
        </ReactMarkdown>
      ) : (
        <>{children}</>
      )}
    </div>
  );
}
